<template>
    <div class="product_list_vtwo">
        <section class="hours_tshirt_banner">
            <div class="container">
                <div class="row">
                    <div class="col-md-5 col-lg-4 pr_52">
                        <img
                            src="/maincss/images/24hour_tshirts_banner_logo.png"
                            alt=" "
                            class="mt_30"
                        />
                    </div>
                    <div class="col-md-7 col-lg-8 pl_72 pr_72">
                        <h1>
                            Get up to 500 White T-shirts printed by tomorrow!
                        </h1>
                        <p class="m-0">
                            Select t-shirts styles only - limited to stock on
                            hand limited to 500 white t -shirts with 4-color
                            imprint in 1-location with vector ready artwork
                        </p>
                        <p class="collapse pt-2" id="collapseExample">
                            <span>
                                At Imprint City, we offer a 24-hour T-shirt
                                printing service on these select white T-shirts.
                                Now you can get up to 500 custom shirts for
                                those last-minute needs without the worry. Our
                                state-of-the-art equipment and skilled staff
                                ensure that your design is printed accurately
                                and with high-quality inks, resulting in a
                                durable and long-lasting shirt even on a tight
                                deadline.. Whether you need shirts for a
                                promotional event, team building activity, or
                                any other occasion, our 24-hour T-shirt service
                                has got you covered! Contact us today to get
                                started on creating your custom white T-shirts!
                            </span>
                        </p>
                        <a
                            href="#"
                            @click="
                                more_info_btn =
                                    more_info_btn == 'More Info'
                                        ? 'Less Info'
                                        : 'More Info'
                            "
                            class="btn btn_outline_primary border_primary_blue text_primary_blue bg-transparent py_12 px_36 mt_18"
                            type="button"
                            data-toggle="collapse"
                            data-target="#collapseExample"
                            aria-expanded="false"
                            aria-controls="collapseExample"
                            >{{ more_info_btn }}</a
                        >
                    </div>
                </div>
            </div>
        </section>

        <div class="yellow-box text-center mb_14">
            <h3 v-if="product_list.length > 1">
                Pricing for these items includes 24 hour turnaround - rush
                service!
            </h3>
            <h3 v-else>
                Pricing for this item includes 24 hour turnaround - rush
                service!
            </h3>
        </div>

        <!-- <Breadcrumb :breadcrumbs="breadcrumbs"></Breadcrumb> -->

        <section class="breadcrumb-section">
            <div class="container">
                <div class="row">
                    <div class="col-md-12 col-lg-6">
                        <nav aria-label="breadcrumb">
                            <ol class="breadcrumb">
                                <li class="breadcrumb-item">
                                    <router-link to="/">Home</router-link>
                                </li>
                                <li class="breadcrumb-item">24hour T-shirt</li>
                            </ol>
                        </nav>
                    </div>

                    <div class="col-md-12 col-lg-6">
                        <div class="short_by new_24_tshirt_icon_sort_by">
                            <div
                                class="select_option sec_opt m-0 justify-content-end"
                            >
                                <label>Sort by</label>
                                <fieldset>
                                    <v-select
                                        label="label"
                                        :reduce="(sorting) => sorting.value"
                                        v-model="listConfig.sorting"
                                        :options="sorting_array"
                                        :placeholder="'sort by'"
                                        @input="getProducts(true)"
                                    ></v-select>
                                </fieldset>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <section
            class="cmn-section item-category-list pt-0 product_list_page_sec sec-24-tshirts"
        >
            <div class="container">
                <div class="row">
                    <div class="col-md-12 apparel">
                        <div
                            class="row"
                            v-if="$route.params.product_type == '4'"
                        >
                            <div
                                class="col-md-12 col-lg-12 col-xl-12 mt-5 mt-lg-0"
                            >
                                <div class="row">
                                    <div
                                        class="col-md-6 col-lg-6 col-xl-3"
                                        v-for="(product, key) in product_list"
                                        :key="'product' + key"
                                    >
                                        <div class="product promodetails">
                                            <div
                                                class="product_image d-flex justify-content-center bg_primary_light_white py_30 position-relative"
                                            >
                                                <router-link
                                                    :to="{
                                                        path:
                                                            '/24hourtshirts/' +
                                                            product.id
                                                    }"
                                                >
                                                    <img
                                                        :src="
                                                            product.t_shirt_24_hour_image
                                                        "
                                                    />
                                                </router-link>
                                                <div class="">
                                                    <div
                                                        class="offer-badge font_size_20 text_light_grey_2 mt_40"
                                                    >
                                                        Coupon Code
                                                    </div>
                                                </div>

                                                <div class="absolute-tittle">
                                                    <div
                                                        class="font_size_24 text-uppercase font-weight-bold"
                                                    >
                                                        get code
                                                    </div>
                                                    <div class="font_size_20">
                                                        {{
                                                            product.product_title
                                                                | capitalize
                                                        }}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div
                                        class="col-md-12 col-lg-12 col-xl-12 align-self-center text-center"
                                        v-show="
                                            product_list.length < 1 && !isBusy
                                        "
                                    >
                                        <div class="product mb-0">
                                            <h3>No results found.</h3>
                                        </div>
                                    </div>
                                </div>
                                <b-pagination
                                    v-show="category_length > 0"
                                    v-model="currentPage"
                                    :total-rows="category_length"
                                    :per-page="itemsPerPage"
                                    class="imprint_pagination"
                                ></b-pagination>
                            </div>
                        </div>
                        <div class="row" v-else>
                            <div class="col-md-12 col-lg-12 col-xl-12">
                                <div class="row">
                                    <div
                                        class="col-md-6 col-lg-6 col-xl-2 product-custom-md-padding"
                                        data-aos="fade-up"
                                        data-aos-delay="100"
                                        data-aos-offset="100"
                                        v-for="(product, key) in product_list"
                                        :key="'product' + key"
                                    >
                                        <div class="product">
                                            <div
                                                class="product_image d-flex justify-content-center bg_primary_light_white py_30 position-relative"
                                            >
                                                <router-link
                                                    :to="{
                                                        name: '24hoursTShirts',
                                                        params: {
                                                            id_of_product:
                                                                product.id
                                                        }
                                                    }"
                                                >
                                                    <img
                                                        class="img-fluid"
                                                        :src="
                                                            product.t_shirt_24_hour_image
                                                        "
                                                    />
                                                </router-link>
                                                <DiscountOffer
                                                    :product="product"
                                                />
                                                <ProductBottomLinks
                                                    :product="product"
                                                    :ref="`bottom-links-${product.id}`"
                                                    @updateFavourites="
                                                        getAllFavoriteProducts
                                                    "
                                                />
                                            </div>
                                            <div class="product_content_main">
                                                <div
                                                    class="product_content mt_22"
                                                >
                                                    <h4 class="product-sku">
                                                        <router-link
                                                            :to="{
                                                                name: '24hoursTShirts',
                                                                params: {
                                                                    id_of_product:
                                                                        product.id
                                                                }
                                                            }"
                                                            >{{
                                                                product.product_number
                                                                    | capitalize
                                                            }}</router-link
                                                        >
                                                    </h4>
                                                    <h5 class="heading5">
                                                        {{
                                                            product.name
                                                                | capitalize
                                                        }}
                                                    </h5>
                                                    <div
                                                        class="d-flex justify-content-center collapsed color_price"
                                                    >
                                                        <DisplayProductPrice
                                                            :product="product"
                                                            :tShirt24Hour="true"
                                                        />

                                                        <DisplayProductColors
                                                            :colors="
                                                                product.colors
                                                            "
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div
                                        class="col-md-12 col-lg-12 col-xl-12 product-custom-md-padding align-self-center text-center"
                                        v-show="
                                            product_list.length < 1 && !isBusy
                                        "
                                    >
                                        <div
                                            class="product mb-0 text-left"
                                            v-if="listConfig.searchKeyword"
                                        >
                                            <div class="span-20 last">
                                                <div
                                                    class="item_container_holder"
                                                >
                                                    <div class="title_holder">
                                                        <h2>
                                                            No Results Found
                                                        </h2>
                                                    </div>

                                                    <div
                                                        class="yCmsContentSlot item_container"
                                                    >
                                                        <div class="content">
                                                            <h2>
                                                                Sorry, we
                                                                couldn't find
                                                                any results for
                                                                your search
                                                            </h2>
                                                            <p>Suggestions:</p>
                                                            <ul class="pl_40">
                                                                <li>
                                                                    You may have
                                                                    typed your
                                                                    keywords
                                                                    incorrectly
                                                                    - please
                                                                    check for
                                                                    misspellings.
                                                                </li>
                                                                <li>
                                                                    You may have
                                                                    been too
                                                                    specific -
                                                                    please
                                                                    broaden your
                                                                    search by
                                                                    using fewer
                                                                    keywords.
                                                                </li>
                                                                <li>
                                                                    Browse our
                                                                    products by
                                                                    selecting a
                                                                    category
                                                                    above.
                                                                </li>
                                                            </ul>
                                                        </div>
                                                    </div>
                                                    <div
                                                        class="item_container"
                                                    ></div>
                                                </div>
                                            </div>
                                        </div>
                                        <div
                                            class="product mb-0 text-center"
                                            v-else
                                        >
                                            <h3>No results found.</h3>
                                        </div>
                                    </div>
                                </div>
                                <div class="pagination_margin">
                                    <b-pagination
                                        v-show="category_length > 0"
                                        v-model="currentPage"
                                        :total-rows="category_length"
                                        :per-page="itemsPerPage"
                                        class="imprint_pagination"
                                    ></b-pagination>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="preloader" v-show="isBusy">
                    <div class="preloader-body">
                        <svg width="40" height="40" viewBox="0 0 40 40">
                            <polygon
                                class="rect"
                                points="0 0 0 40 40 40 40 0"
                            ></polygon>
                        </svg>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>
<script>
import { mapGetters } from "vuex";
import ApiService from "@/common/api.service";
import DisplayProductColors from "@/components/DisplayProductColorsNew";
import DiscountOffer from "@/components/DiscountOfferNew";
import DisplayProductPrice from "@/components/DisplayProductPriceNew";
import ProductBottomLinks from "@/components/ProductBottomLinksNew";
// import Breadcrumb from "@/components/Breadcrumb";

export default {
    name: "ProductList",
    components: {
        DisplayProductColors,
        DiscountOffer,
        DisplayProductPrice,
        ProductBottomLinks
        // Breadcrumb
    },
    data() {
        return {
            sorting_array: [
                { label: "Relevance", value: "" },
                { label: "New", value: "new" },
                { label: "Price, High to Low", value: "price_desc" },
                { label: "Price, Low to High", value: "price_asc" },
                { label: "Name A to Z", value: "name_asc" },
                { label: "Name Z to A", value: "name_desc" }
            ],
            filter: null,
            isBusy: false,
            isbrandShowMore: false,
            isgenderAgeShowMore: false,
            issleevesShowMore: false,
            isstylesShowMore: false,
            isfabricShowMore: false,
            iscolorsShowMore: false,
            isattributesShowMore: false,
            category_list: [],
            product_list: [],
            brand_list: [],
            gender_age_list: [],
            sleeve_list: [],
            style_category_list: [],
            fabric_list: [],
            color_list: [],
            attribute_list: [],
            productTypeName: "Search",
            productTypePath: "/",
            listConfig: {
                offset: (this.currentPage - 1) * this.itemsPerPage,
                limit: this.itemsPerPage,
                sortBy: "",
                order: "ASC",
                brandIds: [],
                gender_age_ids: [],
                searchKeyword: ""
            },
            listConfigCategory: {
                sortBy: "",
                order: "ASC",
                prod_type_id: this.$route.params.product_type,
                category_id: this.$route.params.category_id
            },
            category_length: 0,
            currentPage: 1,
            itemsPerPage: 15,
            breadcrumbs: [],
            more_info_btn: "More Info",
            markup_tiers: []
        };
    },
    async beforeMount() {
        await this.getAllMarkupTiers();
    },
    mounted() {
        this.breadcrumbs = [{ name: "24hour T-shirt" }];
        document.body.classList.remove("bg_primary_light_white");
        var _this = this;
        _this.getAllBrands();
        _this.getGenderSize();
        _this.getSleeves();
        _this.getStyleCategories();
        _this.getFebrics();
        this.getAttributes();
        _this.listConfig = {
            offset: (_this.currentPage - 1) * _this.itemsPerPage,
            limit: _this.itemsPerPage,
            sortBy: "",
            order: "ASC",
            brandIds: [],
            gender_age_ids: [],
            colorNames: [],
            prod_type_id: _this.$route.params.product_type,
            category_id: _this.$route.params.category_id,
            sleevesId: [],
            fabricIds: [],
            styles: [],
            other_attributes: [],
            sorting: ""
        };
        _this.filter = _this.$route.params.filter;
        if (_this.filter) {
            let filter_text = _this.$route.params.filter_text;
            if (_this.filter == "sleeves_id") {
                _this.listConfig.sleevesId.push(filter_text);
            } else if (_this.filter == "fabric_id") {
                _this.listConfig.fabricIds.push(filter_text);
            } else if (_this.filter == "styles") {
                _this.listConfig.styles.push(filter_text);
            } else if (_this.filter == "sizes") {
                _this.listConfig.gender_age_ids.push(filter_text);
            } else if (_this.filter == "other_attributes") {
                _this.listConfig.other_attributes.push(filter_text);
            }
        }

        if (_this.$route.params.product_type == "apparel") {
            _this.listConfig.prod_type_id = "1";
            _this.listConfigCategory.prod_type_id =
                _this.listConfig.prod_type_id;
            _this.productTypePath = "Apparel";
            _this.productTypeName = "Hats";
        } else if (_this.$route.params.product_type == "bags") {
            _this.listConfig.prod_type_id = "2";
            _this.listConfigCategory.prod_type_id =
                _this.listConfig.prod_type_id;
            _this.productTypeName = "Bags";
            _this.productTypePath = "bags";
        } else if (_this.$route.params.product_type == "hats") {
            _this.listConfig.prod_type_id = "3";
            _this.listConfigCategory.prod_type_id =
                _this.listConfig.prod_type_id;
            _this.productTypeName = "Hats";
            _this.productTypePath = "hats";
        } else if (_this.$route.params.product_type == "specials") {
            _this.listConfig.prod_type_id = "5";
            _this.listConfigCategory.prod_type_id =
                _this.listConfig.prod_type_id;
            _this.productTypeName = "Specials";
            _this.productTypePath = "specials";
        } else if (_this.$route.params.product_type == "promos") {
            _this.listConfig.prod_type_id = "4";
            _this.listConfigCategory.prod_type_id =
                _this.listConfig.prod_type_id;
            _this.productTypeName = "Promos";
            _this.productTypePath = "promos";
        } else if (_this.$route.params.product_type == "brand") {
            _this.listConfig.category_id = "";
            _this.listConfig.prod_type_id = "";
            _this.listConfig.brand_id = _this.$route.params.category_id;
            _this.productTypeName = "Brands";
            _this.productTypePath =
                "/product-list/brand/" + _this.$route.params.category_id;
        } else {
            _this.productTypeName = "Search";
            _this.productTypePath = "/product-list/all/all";
        }
        _this.$root.$on("search-product", (data) => {
            _this.listConfig.searchKeyword = data.searchKeyword;
            _this.getProducts(true);
        });
        _this.getProducts(true);
    },
    computed: {
        ...mapGetters([
            "isAuthenticatedClient",
            "currentUserClient",
            "printTemplates",
            "embroideryTemplates"
        ]),
        pages() {
            if (this.category_length <= this.itemsPerPage) {
                return [1];
            }
            return [
                ...Array(
                    Math.ceil(this.category_length / this.itemsPerPage)
                ).keys()
            ].map((e) => e + 1);
        }
    },
    watch: {
        currentPage(newValue) {
            this.listConfig.offset = (newValue - 1) * this.itemsPerPage;
            this.getProducts();
        },
        isAuthenticatedClient(val) {
            if (val) {
                setTimeout(() => {
                    this.getAllFavoriteProducts();
                }, 100);
            }
        }
    },
    methods: {
        getAttributes() {
            var _this = this;
            new Promise(() => {
                ApiService.get("/attributes")
                    .then(({ data }) => {
                        _this.attribute_list = data.attributes;
                    })
                    .catch(({ response }) => {
                        /* eslint-disable */
                        context.commit(SET_ERROR, response.data.errors);
                        /* eslint-enable */
                    });
            });
        },
        showMore(list) {
            var _this = this;
            _this[list] = _this[list] ? false : true;
        },
        CategoryTitle(categories) {
            var _this = this;

            if (_this.$route.params.product_type == "all") {
                let searchValue = _this.listConfig.searchKeyword
                    ? 'Search-"' + _this.listConfig.searchKeyword + '"'
                    : " ";
                return searchValue;
            }
            if (_this.$route.params.product_type == "brand") {
                let brand = _this.brand_list.find(
                    (element) => element.id == _this.$route.params.category_id
                );
                return brand ? brand.name : "";
            }
            return categories ? categories.title : "";
        },
        CategoryBreadcrumbs(categories) {
            var _this = this;
            if (_this.$route.params.product_type == "all") {
                let searchValue = _this.listConfig.searchKeyword
                    ? _this.listConfig.searchKeyword
                    : " ";
                return searchValue;
            }
            if (_this.$route.params.product_type == "brand") {
                let brand = _this.brand_list.find(
                    (element) => element.id == _this.$route.params.category_id
                );
                return brand ? brand.name : "";
            }
            return categories ? categories.title : "";
        },
        getFebrics() {
            var _this = this;
            new Promise(() => {
                ApiService.get("/home-febrics")
                    .then(({ data }) => {
                        _this.fabric_list = data.febrics;
                    })
                    .catch(({ response }) => {
                        console.log(response);
                    });
            });
        },
        getStyleCategories() {
            var _this = this;
            new Promise(() => {
                ApiService.get("/home-styles")
                    .then(({ data }) => {
                        _this.style_category_list = data.styles;
                    })
                    .catch(({ response }) => {
                        console.log(response);
                    });
            });
        },
        getSleeves() {
            var _this = this;
            new Promise(() => {
                ApiService.get("/home-sleeves")
                    .then(({ data }) => {
                        _this.sleeve_list = data.sleeves;
                    })
                    .catch(({ response }) => {
                        console.log(response);
                    });
            });
        },
        getGenderSize() {
            var _this = this;
            new Promise(() => {
                ApiService.get("/home-gender-age-sizes")
                    .then(({ data }) => {
                        // console.log(data);
                        _this.gender_age_list = data.genderagesizes;
                    })
                    .catch(({ response }) => {
                        console.log(response);
                    });
            });
        },
        getAllBrands() {
            var _this = this;
            new Promise(() => {
                ApiService.get("/home-brands")
                    .then(({ data }) => {
                        _this.brand_list = data.brands;
                    })
                    .catch(({ response }) => {
                        console.log(response);
                    });
            });
        },
        getProducts(pagereset = false) {
            var _this = this;
            _this.isBusy = true;
            new Promise(() => {
                if (pagereset) {
                    _this.currentPage = 1;
                    _this.listConfig.offset = 0;
                }
                ApiService.post(
                    "/home-new-product-list-24-tshirt",
                    _this.listConfig
                )
                    .then(({ data }) => {
                        _this.category_length = data.products.count;
                        _this.product_list = data.products.rows;
                        this.product_list.forEach((product) => {
                            product["default_color_id"] = null;
                            product.MainNewSubProducts =
                                product.MainNewSubProducts.filter(
                                    (new_sub_product) =>
                                        new_sub_product.Color.name == "White"
                                );
                            product.colors = [];
                            if (product.MainNewSubProducts.length > 0) {
                                product["default_color_id"] =
                                    product.MainNewSubProducts[0].color_id;
                                let lowest_price_base = parseFloat(
                                    product.MainNewSubProducts[0]["price_base"]
                                );
                                product.MainNewSubProducts.forEach((subproduct) => {
                                    if (
                                        lowest_price_base >
                                        parseFloat(subproduct.price_base)
                                    ) {
                                        lowest_price_base = parseFloat(
                                            subproduct.price_base
                                        );
                                    }
                                });
                                product.price_base = lowest_price_base;
                                product.price_markup_value =
                                    (lowest_price_base *
                                        parseFloat(
                                            product.price_markup_percentage
                                        )) /
                                    100;
                                // product.colors = [product.NewSubProducts[0]['Color']];

                                if (
                                    product.decoration_price_type ==
                                    "global_price"
                                ) {
                                    product.price_markup_percentage =
                                        this.getMarkupFromTier(
                                            product.price_base,
                                            product.decoration_type,
                                            product.decoration_price_template
                                        );
                                    product.price_markup_value =
                                        (parseFloat(product.price_base) *
                                            parseFloat(
                                                product.price_markup_percentage
                                            )) /
                                        100;
                                    if (product.decoration_type == 1) {
                                        let decoration_price_template =
                                            this.printTemplates.find(
                                                (template) =>
                                                    template.id ==
                                                    product.decoration_price_template
                                            );
                                        if (decoration_price_template) {
                                            product.PrintTemplate =
                                                decoration_price_template;
                                            product.price_color_category_dark =
                                                decoration_price_template.price_dark;
                                            product.price_color_category_light =
                                                decoration_price_template.price_light;
                                            product.price_decoration_bulk =
                                                JSON.stringify({
                                                    print_location1:
                                                        decoration_price_template.PrintLocation1Templates
                                                });
                                        }
                                    } else if (product.decoration_type == 2) {
                                        let decoration_price_template =
                                            this.embroideryTemplates.find(
                                                (template) =>
                                                    template.id ==
                                                    product.decoration_price_template
                                            );
                                        if (decoration_price_template) {
                                            product.EmbroideryTemplate =
                                                decoration_price_template;
                                            product.price_color_category_dark =
                                                decoration_price_template.price_dark;
                                            product.price_color_category_light =
                                                decoration_price_template.price_light;
                                            product.price_decoration_bulk =
                                                JSON.stringify(
                                                    decoration_price_template.EmbroideryQuantities
                                                );
                                        }
                                    }
                                }
                            }
                        });
                        if (this.isAuthenticatedClient) {
                            this.getAllFavoriteProducts();
                        }
                        _this.isBusy = false;
                    })
                    .catch((response) => {
                        console.log(response);
                        _this.isBusy = false;
                    });
            });
        },
        getAllMarkupTiers() {
            return new Promise((resolve, reject) => {
                ApiService.get("/get-markup-tiers")
                    .then(({ data }) => {
                        if (data.error) {
                            this.$toast.error(data.error, {
                                position: "top-right",
                                queue: true
                            });
                            return;
                        }
                        this.markup_tiers = data.markup_tiers;
                        resolve(data);
                    })
                    .catch((response) => {
                        reject(response);
                    });
            });
        },
        getMarkupFromTier(price, decoration_type, decoration_price_template) {
            let markup = 0;
            let tier = this.markup_tiers.find(
                (tier) =>
                    decoration_type == tier.decoration_id &&
                    decoration_price_template == tier.template_id &&
                    parseFloat(tier.start_price) <= parseFloat(price) &&
                    parseFloat(tier.end_price) >= parseFloat(price)
            );
            if (tier) {
                markup = tier.markup;
            }
            return markup;
        },
        getAllFavoriteProducts() {
            ApiService.post("/home-allfavorite-products")
                .then(({ data }) => {
                    let favourite_product_ids = data.favorite.map(
                        (product) => product.product_id
                    );
                    this.product_list.forEach((product) => {
                        this.$refs[
                            `bottom-links-${product.id}`
                        ][0].is_favorite_product =
                            favourite_product_ids.includes(product.id);
                        this.$refs[
                            `bottom-links-${product.id}`
                        ][0].favorite_product = data.favorite.find(
                            (fav) => fav.product_id == product.id
                        );
                    });
                })
                .catch(({ response }) => {
                    console.log(response);
                });
        }
    }
};
</script>
